import { Grid, CircularProgress, stepContentClasses } from "@mui/material";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../../utils/API";
import PCard from "../../../components/pos/PCard.jsx";
import PConfirm from "../../../components/pos/PConfirm";
import { useTranslation } from "react-i18next";

export default function AccountingReplay(props) {
  const { t } = useTranslation();
  const translate = t;

  const [financialYearId, setFinancialYearId] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFinancialYear();
  }, []);

  async function loadFinancialYear() {
    let { data } = await API.get("/api/v1/currentfinancialyear");
    setFinancialYearId(data.id);
  }

  async function startMigrationAPI() {
    console.log("startMigration called");
    setLoading(true);
    try {
      let payload = {
        financialYearId: financialYearId,
      };
      let { data } = await API.post("/api/v1/workrequest", {
        actionType: "migrate_pos_data_to_accounting",
        playload: JSON.stringify(payload),
      });

      while (true) {
        let result = await API.get("/api/v1/workrequest/" + data.id);
        console.log(result.data);
        if (result.data.status === "Failed") {
          props.setAlert({
            show: true,
            title: translate("Alert!"),
            message: translate(
              "Account Data  rebuilt failed, please contact support"
            ),
          });
          break;
        } else if (result.data.status === "Completed") {
          props.setAlert({
            show: true,
            title: translate("Success!"),
            message: translate("Account Data has been rebuilt successfully"),
          });
          break;
        }
        await sleep(5000);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
      console.log(err);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function startRecoucileledgersAPI() {
    console.log("startRecoucileledgers called");
    setLoading(true);
    try {
      let payload = {
        financialYearId: financialYearId,
      };
      let { data } = await API.post("/api/v1/workrequest", {
        actionType: "refresh_ledgers",
        playload: JSON.stringify(payload),
      });

      while (true) {
        let result = await API.get("/api/v1/workrequest/" + data.id);
        console.log(result.data);
        if (result.data.status === "Failed") {
          props.setAlert({
            show: true,
            title: translate("Alert!"),
            message: translate(
              "Ledgers will get rebuild failed, please contact support"
            ),
          });
          break;
        } else if (result.data.status === "Completed") {
          props.setAlert({
            show: true,
            title: translate("Success!"),
            message: translate("Ledgers will get rebuild successfully"),
          });
          break;
        }
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
      console.log(err);
    }
  }

  async function onYesNoClicked(context, value) {
    console.log(context, value);
    if (context.eventType === "startMigration" && value === "yes") {
      console.log("startMigration called 1");
      await startMigrationAPI();
    } else if (
      context.eventType === "startRecoucileledgers" &&
      value === "yes"
    ) {
      console.log("startRecoucileledgers called 1");
      await startRecoucileledgersAPI();
    }
    setConfirmOpen(false);

    // setBlockYearEnding(true);
  }

  // function showDetailedError(err) {}

  async function startMigration() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Recreate Accounting Data"),
      message: translate(
        "All Accounting Data will get cleaned and rebuild from POS"
      ),
      type: "warning",
      eventType: "startMigration",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function startRecoucileledgers() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Refresh Accounting Data"),
      message: translate("Are you sure to rebuid Ledgers from Journal entries"),
      type: "warning",
      eventType: "startRecoucileledgers",
      open: true,
      yes: true,
      no: true,
    });
  }

  var biRef = {};
  const content = (
    <div>
      {
        <Button onClick={startMigration} variant="contained" disabled={loading}>
          {loading && <CircularProgress size={20} />}
          Rebuild Ledgers
        </Button>
      }

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );

  const customTitle = "Reconcile Accounting Data";

  return <PCard avatar="R" title={customTitle} content={content}></PCard>;
}
